import { graphql, Link, useStaticQuery } from "gatsby"
import React, { useState } from "react"
import { Col, Container, Row } from "react-bootstrap"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const Category = () => {
  const query = graphql`
    {
      allStrapiBlogs {
        group(field: category, limit: 4) {
          nodes {
            slug
            Image {
              localFile {
                childImageSharp {
                  gatsbyImageData(placeholder: BLURRED)
                }
              }
            }
            category
            title
          }
        }
      }
    }
  `
  const data = useStaticQuery(query)
  const {
    allStrapiBlogs: { group },
  } = data

  const catArr = group?.map(item => item.nodes).flat()

  const [posts, setPosts] = useState(catArr)
  const [heading, setHeading] = useState("all")
  const newArr = ["all", ...new Set(catArr.map(item => item.category))]

  const handleFilter = cat => {
    if (cat === "all") {
      setPosts(catArr)
      setHeading("all")
      return
    }
    const finalPosts = catArr.filter(item => item.category === cat)
    setPosts(finalPosts)
    setHeading(finalPosts[0].category)
  }

  return (
    <Container className="category-home-posts my-5">
      <h1 className="rb r-h1 my-5 text-center">Recent Posts</h1>
      <div className="d-flex mb-4 mb-lg-5 justify-content-center align-items-center flex-wrap">
        {newArr.map((item, i) => {
          return (
            <button
              key={i}
              onClick={() => handleFilter(item)}
              className="btn c-btn rb"
            >
              {item}
            </button>
          )
        })}
      </div>

      <div className="d-flex align-items-center">
        <h1 className="me-4 me-lg-5">{heading}</h1>
        {heading === "all" ? (
          ""
        ) : (
          <Link className="colorr" to={`/blog/${heading}#explore`}>
            View all
          </Link>
        )}
      </div>

      <Row>
        {posts.map((item, i) => {
          const path = getImage(item.Image.localFile)
          return (
            <Col lg={3} md={6} xs={6} key={i} className="p-items">
              <Link to={`/blog/${item.category}/${item.slug}`}>
                <GatsbyImage image={path} alt={item.title} />
              </Link>
              <Link to={`/blog/${item.category}`}>
                <p className="my-2 cat">{item.category}</p>
              </Link>
              <Link to={`/blog/${item.category}/${item.slug}`}>
                <h1 className="rb">{item.title}</h1>
              </Link>
            </Col>
          )
        })}
      </Row>
    </Container>
  )
}

export default Category
